<template>
  <div class="dashboard-container kuota">
    <div class="mb-2 page-title">
      <i class="bi bi-people-fill"></i> Ketersediaan Kelas
    </div>

    <p class="kuota__intro">
      Daftar ini menunjukkan jumlah atlet dan tim yang sudah terdaftar di tiap kelas Tanding dan nomor Seni.
      Slot terhitung terpakai sejak didaftarkan atau dibuat tagihan agar tidak ada kontingen yang bentrok mengisi slot terakhir yang sama.
    </p>

    <!-- Pilih turnamen -->
    <div class="ui-field mb-4">
      <label for="kuota-turnamen" class="ui-label">Turnamen</label>
      <select id="kuota-turnamen" v-model="turnamenId" class="form-control" @change="muat">
        <option value="">Pilih Turnamen</option>
        <option v-for="t in turnamenList" :key="t.id" :value="t.id">{{ t.name }}</option>
      </select>
    </div>

    <div v-if="memuat" class="kuota__pesan">
      <span class="spinner-border"></span> Menghitung keterisian kelas & nomor seni...
    </div>

    <template v-else-if="turnamenId">
      <!-- Pemberitahuan jika Panitia Tidak Mengizinkan Tampilan Kuota ke Official -->
      <div v-if="!diizinkanPanitia && !isPanitia" class="alert alert-warning d-flex align-items-center gap-3 p-3 my-3 rounded-3 shadow-sm">
        <i class="bi bi-eye-slash-fill fs-2 text-warning flex-shrink-0"></i>
        <div>
          <strong class="d-block">Tampilan Ketersediaan Kelas Dinonaktifkan oleh Panitia</strong>
          <span class="small text-secondary">
            Panitia/Admin turnamen ini memilih untuk tidak menampilkan rincian keterisian kelas. Pembatasan kuota tetap berjalan otomatis saat Anda mengisi formulir atlet (kelas yang penuh otomatis tidak dapat dipilih dan berwarna abu-abu).
          </span>
        </div>
      </div>

      <template v-else>
        <!-- Ringkasan -->
        <div v-if="kelas.length" class="ringkas">
          <div class="ringkas__kotak">
            <strong>{{ ringkasan.total_kelas }}</strong><span>total nomor/kelas</span>
          </div>
          <div class="ringkas__kotak">
            <strong>{{ ringkasan.dibatasi }}</strong><span>dibatasi kuota</span>
          </div>
          <div class="ringkas__kotak ringkas__kotak--penuh">
            <strong>{{ ringkasan.penuh }}</strong><span>sudah penuh</span>
          </div>
        </div>

      <!-- Tab Filter Jenis Pertandingan -->
      <div class="kategori-tabs mb-3">
        <button
          type="button"
          class="tab-btn"
          :class="{ active: jenisAktif === 'semua' }"
          @click="jenisAktif = 'semua'"
        >
          Semua ({{ kelas.length }})
        </button>
        <button
          type="button"
          class="tab-btn"
          :class="{ active: jenisAktif === 'tanding' }"
          @click="jenisAktif = 'tanding'"
        >
          <i class="bi bi-shield-shaded me-1"></i> Tanding ({{ hitungJenis('tanding') }})
        </button>
        <button
          type="button"
          class="tab-btn"
          :class="{ active: jenisAktif === 'seni' }"
          @click="jenisAktif = 'seni'"
        >
          <i class="bi bi-stars me-1"></i> Seni ({{ hitungJenis('seni') }})
        </button>
      </div>

      <!-- Alat saring -->
      <div class="kuota__alat">
        <input v-model="cari" type="search" class="form-control"
               placeholder="Cari kelas, nomor seni, atau kategori usia..." aria-label="Cari kelas" />

        <label class="kuota__saring">
          <input type="checkbox" v-model="hanyaDibatasi" />
          <span class="kuota__saring-teks">Hanya yang dibatasi</span>
        </label>
      </div>

      <!-- Daftar -->
      <div v-for="(daftar, usia) in dikelompokkan" :key="usia" class="kelompok">
        <h2 class="kelompok__judul">
          <span>{{ usia }}</span>
          <span class="kelompok__batas">
            {{ infoBatasUsia(daftar) }}
          </span>
        </h2>

        <ul class="kelas-daftar">
          <li v-for="k in daftar" :key="k.id" class="kelas"
              :class="{ 'kelas--penuh': k.penuh, 'kelas--hampir': hampirPenuh(k) }">
            <div class="kelas__kiri">
              <span class="kelas__nama">
                <span class="badge-tipe" :class="k.jenis === 'tanding' ? 'badge-tipe--tanding' : 'badge-tipe--seni'">
                  {{ k.jenis === 'tanding' ? 'TANDING' : 'SENI' }}
                </span>
                {{ k.nama_kelas }}
                <span class="kelas__gender">{{ k.gender === 'female' ? 'Putri' : 'Putra' }}</span>
                <span v-if="k.is_team" class="badge-tim">Tim</span>
              </span>
              <span v-if="k.berat_min || k.berat_max" class="kelas__berat">
                Rentang berat: {{ k.berat_min }}–{{ k.berat_max }} kg
              </span>
            </div>

            <div class="kelas__kanan">
              <!-- Tanpa batas: bilah kemajuan tidak punya makna, jadi tidak digambar -->
              <template v-if="k.dibatasi">
                <div class="bilah" :aria-label="`${k.terisi} dari ${k.kuota} terisi`">
                  <div class="bilah__isi" :style="{ width: persen(k) + '%' }"></div>
                </div>
                <span class="kelas__angka">
                  <strong>{{ k.terisi }}</strong>/{{ k.kuota }} {{ k.is_team ? 'tim' : 'slot' }}
                </span>
                <span class="kelas__status" :class="`kelas__status--${nada(k)}`">
                  {{ label(k) }}
                </span>
              </template>

              <template v-else>
                <span class="kelas__angka"><strong>{{ k.terisi }}</strong> {{ k.is_team ? 'tim' : 'atlet' }}</span>
                <span class="kelas__status kelas__status--bebas">Tanpa batas</span>
              </template>
            </div>
          </li>
        </ul>
      </div>

      <p v-if="!tersaring.length" class="kuota__pesan">
        Tidak ada kelas atau nomor yang cocok dengan penyaringan saat ini.
      </p>
      </template>
    </template>

    <p v-else class="kuota__pesan">Pilih turnamen untuk melihat keterisian kelas dan nomor seninya.</p>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import http from '@/services/http';
import { hanyaTerlihat } from '@/utils/status';

export default {
  name: 'KetersediaanKelasPage',

  setup() {
    return { toast: useToast() };
  },

  data() {
    return {
      turnamenList: [],
      turnamenId: '',
      kelas: [],
      ringkasan: { total_kelas: 0, dibatasi: 0, penuh: 0 },
      diizinkanPanitia: true,
      cari: '',
      jenisAktif: 'semua',
      hanyaDibatasi: false,
      memuat: false,
    };
  },

  computed: {
    isPanitia() {
      const role = localStorage.getItem('userRole') || '';
      return ['owner', 'admin', 'event pic'].some((r) => role.toLowerCase().includes(r));
    },

    tersaring() {
      const kata = this.cari.trim().toLowerCase();

      return this.kelas.filter((k) => {
        if (this.jenisAktif !== 'semua' && k.jenis !== this.jenisAktif) return false;
        if (this.hanyaDibatasi && !k.dibatasi) return false;
        if (!kata) return true;
        return `${k.nama_kelas} ${k.kategori_usia} ${k.kategori_tanding}`.toLowerCase().includes(kata);
      });
    },

    /** Dikelompokkan per kategori usia — cara panitia dan pelatih berpikir. */
    dikelompokkan() {
      return this.tersaring.reduce((wadah, k) => {
        (wadah[k.kategori_usia] ||= []).push(k);
        return wadah;
      }, {});
    },
  },

  mounted() {
    this.muatTurnamen();
  },

  methods: {
    hitungJenis(jenis) {
      return this.kelas.filter((k) => k.jenis === jenis).length;
    },

    infoBatasUsia(daftar) {
      if (!Array.isArray(daftar) || !daftar.length) return '';
      const pertama = daftar[0];
      const hasil = [];

      const batasT = pertama.kuota_tanding_kategori || daftar.find(k => k.jenis === 'tanding')?.kuota;
      const batasS = pertama.kuota_seni_kategori || daftar.find(k => k.jenis === 'seni')?.kuota;

      if (batasT) hasil.push(`Kuota Tanding: ${batasT} / kelas`);
      if (batasS) hasil.push(`Kuota Seni: ${batasS} / nomor`);

      return hasil.join('  •  ');
    },

    labelBatas(daftar) {
      return this.infoBatasUsia(daftar);
    },

    persen(k) {
      if (!k.kuota) return 0;
      return Math.min(100, Math.round((k.terisi / k.kuota) * 100));
    },

    /** Sisa dua kursi atau kurang dianggap kritis. */
    hampirPenuh(k) {
      return k.dibatasi && !k.penuh && k.sisa <= 2;
    },

    nada(k) {
      if (k.penuh) return 'penuh';
      if (this.hampirPenuh(k)) return 'hampir';
      return 'longgar';
    },

    label(k) {
      if (k.penuh) return 'PENUH';
      const unit = k.is_team ? 'tim' : 'slot';
      if (k.sisa === 1) return `Sisa 1 ${unit}`;
      return `Sisa ${k.sisa}`;
    },

    async muatTurnamen() {
      try {
        const { data } = await http.get('/tournaments', { params: { fetch_all: true } });
        const daftar = Array.isArray(data) ? data : data.data || [];
        this.turnamenList = hanyaTerlihat(daftar);

        if (this.turnamenList.length === 1) {
          this.turnamenId = this.turnamenList[0].id;
          this.muat();
        }
      } catch (e) {
        this.toast.error('Gagal memuat daftar turnamen.');
      }
    },

    async muat() {
      if (!this.turnamenId) {
        this.kelas = [];
        return;
      }

      this.memuat = true;
      try {
        const { data } = await http.get('/billings/kuota-kelas', {
          params: { tournament_id: this.turnamenId },
        });
        this.kelas = data.kelas || [];
        this.ringkasan = data.ringkasan || this.ringkasan;
        this.diizinkanPanitia = data.tampilkan_kuota_kelas !== undefined ? Boolean(data.tampilkan_kuota_kelas) : true;
      } catch (e) {
        this.kelas = [];
        this.toast.error(e?.response?.data?.message || 'Gagal memuat keterisian kelas.');
      } finally {
        this.memuat = false;
      }
    },
  },
};
</script>

<style scoped>
/* ── Tabs Kategori ── */
.kategori-tabs {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: 2px;
}
.kategori-tabs::-webkit-scrollbar { display: none; }

.tab-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 1rem;
  font-size: var(--text-xs);
  font-weight: 600;
  border-radius: var(--radius-full);
  border: 1px solid var(--border-subtle);
  background: var(--bg-surface);
  color: var(--text-secondary);
  cursor: pointer;
  white-space: nowrap;
  transition: all var(--transition-fast);
}

.tab-btn:hover {
  background: var(--bg-sunken);
  color: var(--text-primary);
}

.tab-btn.active {
  background: var(--accent-gradient, var(--primary));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.badge-tipe {
  display: inline-block;
  padding: 1px 6px;
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  border-radius: var(--radius-sm);
  margin-right: 2px;
}
.badge-tipe--tanding {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}
.badge-tipe--seni {
  background: rgba(168, 85, 247, 0.12);
  color: #9333ea;
}

[data-theme='dark'] .badge-tipe--tanding {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}
[data-theme='dark'] .badge-tipe--seni {
  background: rgba(168, 85, 247, 0.2);
  color: #c084fc;
}

.badge-tim {
  padding: 1px 6px;
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--warning-600, #d97706);
  background: rgba(217, 119, 6, 0.12);
  border-radius: var(--radius-full);
}

.kuota__intro {
  font-size: var(--text-sm);
  line-height: 1.7;
  color: var(--text-secondary);
  margin-bottom: var(--space-5);
}

.kuota__pesan { padding: var(--space-8); text-align: center; color: var(--text-muted); }

/* ── Ringkasan ── */
.ringkas {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

.ringkas__kotak {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3);
  text-align: center;
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}

.ringkas__kotak strong {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  color: var(--text-primary);
}

.ringkas__kotak span { font-size: var(--text-xs); color: var(--text-muted); }
.ringkas__kotak--penuh strong { color: var(--danger-600); }

/* ── Alat ── */
.kuota__alat {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

@media (min-width: 640px) {
  .kuota__alat { flex-direction: row; align-items: center; }
  .kuota__alat .form-control { max-width: 340px; }
}

.kuota__saring {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.kuota__saring * { color: inherit; }
.kuota__saring-teks { color: var(--text-secondary) !important; }
.kuota__saring input { width: 16px; height: 16px; accent-color: var(--accent); color: var(--text-secondary); }

/* ── Kelompok ── */
.kelompok { margin-bottom: var(--space-6); }

.kelompok__judul {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  margin: 0 0 var(--space-3);
  padding-bottom: var(--space-2);
  font-family: var(--font-display);
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-subtle);
}

.kelompok__batas {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Kelas ── */
.kelas-daftar { list-style: none; margin: 0; padding: 0; display: grid; gap: var(--space-2); }

.kelas {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-left: 3px solid var(--border-strong);
  border-radius: var(--radius-md);
}

.kelas--hampir { border-left-color: var(--accent); }
.kelas--penuh  { border-left-color: var(--danger-600); background: var(--bg-sunken); }

@media (min-width: 640px) {
  .kelas { flex-direction: row; align-items: center; justify-content: space-between; }
}

.kelas__kiri { display: flex; flex-direction: column; gap: 2px; min-width: 0; }

.kelas__nama {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  font-weight: 700;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.kelas__gender {
  padding: 1px 6px;
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--text-muted);
  background: var(--bg-sunken);
  border-radius: var(--radius-full);
}

.kelas__berat { font-size: var(--text-xs); color: var(--text-muted); }

.kelas__kanan {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

/* ── Bilah keterisian ── */
.bilah {
  width: 80px;
  height: 6px;
  background: var(--bg-sunken);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.bilah__isi {
  height: 100%;
  background: var(--success-500);
  border-radius: var(--radius-full);
  transition: width var(--transition-base);
}

.kelas--hampir .bilah__isi { background: var(--accent); }
.kelas--penuh  .bilah__isi { background: var(--danger-600); }

.kelas__angka { font-size: var(--text-xs); color: var(--text-muted); white-space: nowrap; }
.kelas__angka strong { font-size: var(--text-sm); color: var(--text-primary); }

.kelas__status {
  padding: 2px var(--space-2);
  font-size: 0.65rem;
  font-weight: 700;
  white-space: nowrap;
  border-radius: var(--radius-full);
}

.kelas__status--longgar { color: var(--success-600); background: rgb(22 163 74 / 0.12); }
.kelas__status--hampir  { color: var(--text-brand); background: var(--accent-subtle); }
.kelas__status--penuh   { color: var(--danger-600); background: rgb(220 38 38 / 0.12); }
.kelas__status--bebas   { color: var(--text-muted); background: var(--bg-sunken); }

@media (prefers-reduced-motion: reduce) { .bilah__isi { transition: none; } }
</style>
